export default "__VITE_ASSET__De1_ZyaS__"